<template>
  <v-layout class="bottom-actions" :style="{direction: params.direction}">
    <v-btn v-for="action in params.actions" text @click="actionClicked(action)" :key='action.action'>{{action.label}}</v-btn>
  </v-layout>

</template>

<script>

  export default {
    name: "VCBottomActions",
    props: ['params'],
    methods: {
      actionClicked(action) {
        this.$emit('actionClicked', action)
      }
    }
  };
</script>
<style lang="scss">
  @import "../../../assets/scss/abstract/_variables.scss";

  .bottom-actions{
    margin: 0;
    max-height: 49px;
    background: #ffffff;

    .v-btn:not(.v-btn--round).v-size--default{
      height: 49px;
    }

    .v-btn{
      font-size: 12px;
      font-weight: 600;
      color: $buttonTextColor;
      cursor: pointer;

      &:hover{
        background-color:rgba(158,158,158,0.2);
      }

      &.disable{
        color: $actionDisable;
        pointer-events: none;
      }
    }
  }

</style>
